import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, TextField, Box, Typography } from "@mui/material";
import useUser from "../../../../hooks/useUser";
import { useDialog } from "../../../../contexts/DialogContext";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const DeleteUserDialog = ({ userId }) => {
  const [comment, setComment] = useState("");
  const { deleteRadUser } = useUser();
  const { unSetDialog } = useDialog();
  const dispatch = useDispatch();

  const handleDelete = async () => {
    if (!comment) {
      alert("Please provide a comment for deletion");
      return;
    }
    try {
      await deleteRadUser(userId, comment);
      dispatch(showSuccessSnackbar("User deleted successfully"));
      unSetDialog("delete_user");
      // Reload to refresh the list
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Deletion failed:", error);
      dispatch(showErrorSnackbar("Failed to delete user: " + error));
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body1" gutterBottom>
        Are you sure you want to permanently delete this user?
      </Typography>
      <TextField
        fullWidth
        label="Reason for deletion"
        multiline
        rows={4}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        margin="normal"
        required
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button onClick={() => unSetDialog("delete_user")} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button onClick={handleDelete} variant="contained" color="error">
          Delete
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteUserDialog;
